'use client';

import R2Image from '@/components/ui/R2Image';
import RichText from '@/components/ui/RichText/RichText';
import BalancedContentSection from '@/components/sections/BalancedContentSection/BalancedContentSection';
import { OurOfficesSection } from '@/features/aboutUs/hooks/types';

const OurOffices = ({ data }: { data: OurOfficesSection }) => {
  if (!data) return null;

  const { heading, description, imageUrl } = data;

  return (
    <div className="pt-8 pb-6 md:pt-10 md:pb-8">
      <BalancedContentSection
        spacingClassName="py-8"
        data={{
          ...data,
          backgroundColor: 'bg-surface-light',
          textPosition: 'left',
        }}
        mediaContent={
          <div className="overflow-hidden rounded-lg">
            <R2Image
              path={imageUrl}
              width={604}
              alt={'our mission image'}
              height={411}
              className="h-102.75 w-full rounded-lg object-cover lg:w-152.75 lg:min-w-152.75"
              sizes="(min-width: 611px) 611px, 100vw"
            />
          </div>
        }
        textContent={
          <>
            <RichText
              styles={
                heading?.styles || {
                  h2: 'text-h2 text-royal-500',
                  em: 'text-h2 text-royal-500 lg:block not-italic mt-3',
                }
              }
            >
              {heading?.content}
            </RichText>
            <RichText
              styles={
                description?.styles || {
                  p: 'text-body text-text-body-dark mt-4',
                }
              }
            >
              {description?.content}
            </RichText>
          </>
        }
      />
    </div>
  );
};

export default OurOffices;
